<template>

    <div class="wrapper-scrolling">
        <div class="scrolling-wrapper-flexbox" id="scrollstyle">

            <div class="card">
                <router-link to="products-tv">
                    <div class="icon-box" :class="{'icon-box-active': $route.path === '/products-tv' || $route.path === '/' }">
                        <img id="edit-img" :src="menu.category_monitor" alt="icon">
                    </div>
                </router-link>
                <div align="center" class="font-flexbox">TV</div>
            </div>

            <div class="card">
                <router-link to="products-headphone">
                    <div class="icon-box" :class="{'icon-box-active': $route.path === '/products-headphone'}">
                        <img :src="menu.category_headphone" alt="icon">
                    </div>
                </router-link>
                <div align="center" class="font-flexbox">Headphone</div>
            </div>

            <div class="card">
                <router-link to="products-sound">
                    <div class="icon-box" :class="{'icon-box-active': $route.path === '/products-sound'}">
                        <img :src="menu.category_music" alt="icon">
                    </div>
                </router-link>
                <div align="center" class="font-flexbox">Sound</div>
            </div>

            <div class="card">
                <router-link to="products-camera">
                    <div class="icon-box" :class="{'icon-box-active': $route.path === '/products-camera'}">
                        <img :src="menu.category_camera" alt="icon">
                    </div>
                </router-link>
                <div align="center" class="font-flexbox">Camera</div>
            </div>

            <div class="card">
                <router-link to="products-lens">
                    <div class="icon-box" :class="{'icon-box-active': $route.path === '/products-lens'}">
                        <img :src="menu.category_aperture" alt="icon">
                    </div>
                </router-link>
                <div align="center" class="font-flexbox">Lens</div>
            </div>

            <div class="card">
                <router-link to="products-playstation">
                    <div class="icon-box" :class="{'icon-box-active': $route.path === '/products-playstation'}">
                        <img :src="menu.category_play" alt="icon">
                    </div>
                </router-link>
                <div align="center" class="font-flexbox">PlayStation</div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Category",
        data(){
            return {
                // รูปและไอค็อนส่วนของหน้าเว็บหลัก
                menu: {
                    category_monitor: require('../assets/input/desktop-monitor.png'),
                    category_headphone: require('../assets/input/headphone-symbol.png'),
                    category_music: require('../assets/input/music.png'),
                    category_camera: require('../assets/input/photo-camera.png'),
                    category_aperture: require('../assets/input/aperture.png'),
                    category_play: require('../assets/input/playstation-logotype.png'),
                },
            }
        }
    }
</script>

<style lang="scss" scoped>
    .scrolling-wrapper-flexbox {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        margin: 0 10px;
        background-color: transparent;
    }

    .font-flexbox {
        font-size: 10.5px;
    }


    .card {
        flex: 0 0 auto;
        margin: 15px 0;
        margin-right: 10px;
        padding: 0 5px;
        border: white;
        background-color: transparent;

    }

    @media (min-width: 1080px)
    and (min-width: 1024px)
    and (min-width: 768px) {
        .card {
            flex: 0 0 auto;
            margin: 15px auto;
            padding: 0 auto;
            border: white;
            background-color: transparent;

        }

    }

    .icon-box {
        display: flex;
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.25);

    }

    .icon-box img {
        margin: auto;

    }

    .icon-box:hover,
    .icon-box-active{
        /*background-color: #b26a23;*/
        /*-webkit-filter: invert(100%) !important;*/
        background: linear-gradient(135.9deg, #007581 0%, #2A3186 101.61%);
        img {
            -webkit-filter: invert(100%) !important;
        }
    }

    /*#scrollstyle::-webkit-scrollbar-track*/
    /*{*/
    /*    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
    /*    background-color: #F5F5F5;*/
    /*}*/

    /*#scrollstyle::-webkit-scrollbar*/
    /*{*/
    /*    width: 6px;*/
    /*    background-color: #F5F5F5;*/
    /*}*/

    /*#scrollstyle::-webkit-scrollbar-thumb*/
    /*{*/
    /*    background-color: #000000;*/
    /*    border: 2px solid #555555;*/
    /*}*/

</style>
